<template>
  <div class="card" style="min-height: 300px;">
    <div class="p-3 pb-0 card-header">
      <div class="d-flex align-items-center">
        <h6 class="mb-0">{{ title }}</h6>
      </div>
    </div>
    <div class="p-3 card-body">
      <div class="row">
        <div class="text-center col-12" style="height:300px">
          <div class="chart">
            <canvas :id="id" class="chart-canvas" height="300"></canvas>
          </div>
          <h4 class="font-weight-bold mt-n8">
            
          </h4>
        </div>
      </div> 
      <div class="row mt-3">
        <div class="col-md-3 mb-2" :key="item" v-for="(item, index) in datas">
          <div class="row">
            <div class="col-md-9">
              <div class="px-2 py-0 d-flex">
                <span class="badge me-2" v-bind:style="{ backgroundColor: colors[index]}">&nbsp;</span>
                <div class="d-flex flex-column justify-content-center">
                  <h6 class="mb-0 text-sm">{{labels[index]}}</h6>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="d-flex flex-column align-items-end">
                <h6 class="mb-0 text-sm">{{item}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  name: "consumption-by-room-chart",
  props: {
    labels: Array,
    id: String,
    datas: Array,
    colors: Array,
    title: String,
  },
  mounted() {
    var ctx1 = document.getElementById(this.id).getContext("2d");
    new Chart(ctx1, {
      type: "bar",
      data: {
        labels: this.labels,
        datasets: [
          {
            label: this.title,
            backgroundColor: this.colors,
            data: this.datas,
            fill: true,
          },
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'top',
            font: {
                weight: 'bold'
            }
          },
        },
        layout: {
            padding: {
                top: 10
            }
        },
        onAnimationComplete: function () {

          var ctx = this.chart.ctx;
          ctx.font = this.scale.font;
          ctx.fillStyle = this.scale.textColor
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";

          this.datasets.forEach(function (dataset) {
              dataset.bars.forEach(function (bar) {
                  ctx.fillText(bar.value, bar.x, bar.y - 5);
              });
          })
        },
        interaction: {
          intersect: false,
          mode: "index",
        },
        scales: {
          y: {
            grid: {
              drawBorder: false,
              display: false,
              drawOnChartArea: false,
              drawTicks: false,
            },
            ticks: {
              display: false,
            },
          },
          x: {
            grid: {
              drawBorder: false,
              display: false,
              drawOnChartArea: false,
              drawTicks: false,
            },
            ticks: {
              display: false,
            },
          },
        },
      },
    });
    this.$forceUpdate();
  },
};
</script>
